import { getBasicAuthString, value } from '@takeshape/util';
import isString from 'lodash/isString.js';
import { hasEveryKey } from "../util/has.js";
const serviceProvider = {
    name: 'notion',
    title: 'Notion',
    description: "Use the API to access Notion's pages, databases, and users",
    categories: ['content', 'database'],
    links: [
        { title: 'Homepage', url: 'https://notion.so' },
        { title: 'API Docs', url: 'https://developers.notion.com/reference/intro' }
    ],
    serviceType: 'rest',
    createId: value('notion'),
    getFormSchema: value({
        type: 'object',
        properties: {
            id: {
                title: 'Slug',
                type: 'string',
                pattern: '^[0-9a-z_-]+$',
                default: 'notion'
            },
            title: {
                title: 'Name',
                type: 'string',
                default: 'Notion'
            }
        },
        required: ['title', 'id']
    }),
    getFormConfig: value({
        order: ['title', 'id', 'authentication'],
        properties: {
            title: {
                widget: 'singleLineText',
                instructions: 'A human-readable title for this service.'
            },
            id: {
                widget: 'singleLineText',
                instructions: 'A unique, url-safe identifier for this service.'
            }
        }
    }),
    getConfig(formData) {
        const config = {
            serviceType: 'rest',
            provider: 'notion',
            authenticationType: 'oauth2Bearer',
            id: formData.id ?? 'notion',
            title: formData.title ?? 'Notion',
            options: {
                endpoint: 'https://api.notion.com/v1/',
                headers: {
                    'Notion-Version': '2021-08-16'
                }
            }
        };
        return config;
    },
    checkQueryParams: value({}),
    getServerAuthentication: (options) => ({
        type: 'oauth2',
        authorizationUrl: 'https://api.notion.com/v1/oauth/authorize?owner=user',
        accessTokenUrl: 'https://api.notion.com/v1/oauth/token',
        clientId: 'notionClientId',
        clientSecret: 'notionClientSecret',
        responseType: 'code',
        grantType: 'authorization_code',
        owner: 'user',
        redirectUrl: isString(options.apiBaseUrl) ? `${options.apiBaseUrl}/oauth/notion/redirect` : '',
        getTokenRequest: (url, params) => ({
            url,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Basic ${getBasicAuthString({ username: params.client_id, password: params.client_secret })}`
            },
            json: {
                grant_type: 'authorization_code',
                code: params.code,
                redirect_uri: params.redirect_uri
            }
        })
    }),
    isCompleteConfig: hasEveryKey(['authentication'])
};
export default serviceProvider;
